export default __webpack_public_path__ + "static/media/bg-tablet-pattern.b6990a98.svg";